import { Component, Input } from '@angular/core';
import { RedirectService } from '../../shared/redirect.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent {
  @Input() errorDescription = '¡No esperes más! Tenemos una amplia gama de productos que se ajustan a tus necesidades. ';
  @Input() descFooter = `Todos Los Derechos Reservados. ${this.currentYear} © Banco de Bogotá.`;
  @Input() errTitle = 'Aún no tienes productos con nosotros';
  @Input() labelBtn = 'Terminar';

  constructor(
    private readonly redirectService: RedirectService,
  ) { }

  private get currentYear() {
    return new Date().getFullYear();
  }

  onBtnClick(): void {
    this.redirectService.quit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/error-page/error-page.component.ts